import { BaseController } from 'controllers/BaseController'
import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import { GetContext } from 'store/storeUtils'

interface ISCSNQuotationAPI {
  deleteQuotation: (id: string) => Promise<void>
  downloadUbl: (id: string) => Promise<boolean>
  sendToSCSN: (id: string) => Promise<void>
}

class SCSNQuotationAPI extends InternalAPI implements ISCSNQuotationAPI {
  constructor(partyId: string, onRequestChange: OnRequestChangeCallback) {
    super(`/api/parties/${partyId}/quotations`, onRequestChange)
  }

  public async deleteQuotation(id: string): Promise<void> {
    return this.DeleteAsync({
      relativePath: `/${id}`,
      id: `DeleteSCSNQuotation-${id}`,
    })
  }

  public async downloadUbl(id: string): Promise<boolean> {
    return this.DownloadAsync({
      relativePath: `/${id}/DownloadUbl`,
      id: `DownloadSCSNQuotation-${id}`,
    })
  }

  public async sendToSCSN(id: string): Promise<void> {
    return this.PostAsync({
      relativePath: `/${id}/SendToSCSN`,
      id: `SendToSCSNQuotation-${id}`,
    })
  }
}

export class SCSNQuotationController extends BaseController<ISCSNQuotationAPI> {
  constructor() {
    super((onRequestChange) => {
      const { partyId } = GetContext()
      return new SCSNQuotationAPI(partyId, onRequestChange)
    })
  }

  public async deleteQuotation(id: string): Promise<void> {
    try {
      await this.api.deleteQuotation(id)
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public async downloadUbl(id: string): Promise<boolean> {
    try {
      return await this.api.downloadUbl(id)
    } catch (err) {
      throw this.HandleError(err)
    }
  }

  public async sendToSCSN(id: string): Promise<void> {
    try {
      return await this.api.sendToSCSN(id)
    } catch (err) {
      throw this.HandleError(err)
    }
  }
}
